import React from 'react'

const Label = labelText => (
  <div>
    <label className="form-label">{labelText}</label>
  </div>
)

export default Label



// WEBPACK FOOTER //
// ./src/components/form/Label.js